export const formatDifferences = (formulaString, differencesObject) => {
    let formulaStringResult = formulaString

    if (differencesObject) {
        let currentRangeLength = 0
        let currentRange = []

        // Create a deep copy of the differencesObject to avoid mutating the input
        const differencesObjectCopy = JSON.parse(JSON.stringify(differencesObject))

        Object.keys(differencesObjectCopy).forEach(key => {
            const span1 = `<span class='xls-diff-${key}'>`
            const span2 = '</span>'

            const differenceTypeArray = differencesObjectCopy[key]
            for (let i = 0; i < differenceTypeArray.length; i++) {
                currentRange = differenceTypeArray[i]
                currentRangeLength = currentRange[1] - currentRange[0]
                formulaStringResult = formulaStringResult.replace(
                    new RegExp('^(.{' + currentRange[0] + '})(.{' + currentRangeLength + '})'),
                    '$1' + span1 + '$2' + span2,
                )
                differenceTypeArray[i] = [-1, -1]

                Object.keys(differencesObjectCopy).forEach(innerKey => {
                    const checkArray = differencesObjectCopy[innerKey]
                    for (let j = 0; j < checkArray.length; j++) {
                        if (checkArray[j][0] !== -1 && checkArray[j][0] >= currentRange[0]) {
                            checkArray[j][0] += span1.length + span2.length
                            checkArray[j][1] += span1.length + span2.length
                        }
                    }
                })
            }
        })
    }

    return formulaStringResult
}
